import React from 'react';

export default (props) => {
	const { prdClass="",  returnsMessage } = props;
	let message = returnsMessage || "HP.com will accept returns or exchanges for this product up to 30 days after delivery.";

	if(["vgc","pgc"].includes(prdClass.toLowerCase())){
		message = "This product cannot be returned except where required by law."
	}

    return (
        <div className='pdp-returns'>
            <h2 tabIndex={0} aria-label="Return & exchange information">Return & exchange information</h2>
            <p tabIndex={0} aria-label={message}>{message}</p>
        </div>
    )
}